export const roadmap = [
    {
        id: 1,
        name: "SSC Board",
        institution: "Holy Family High School",
        text: "93% | School Topper | State Subject Topper",
        category: "education",
        date: "2015-2016"
    },
    {
        id: 2,
        name: "HSSC Board",
        institution: "Don Bosco Higher Secondary School",
        text: "84.5% | Top 1% of Goa",
        category: "education",
        date: "2016-2018"
    },
    {
        id: 3,
        name: "B.E. in E&TC Engineering",
        institution: "Goa College of Engineering",
        text: "Best Outgoing Student 2022",
        category: "education",
        date: "2018-2022"
    },
    {
        id: 4,
        name: "Content Writer",
        institution: "Brizzo Digital",
        text: "Internship",
        category: "work",
        date: "2020"
    },
    {
        id: 5,
        name: "Magazine Editor",
        institution: "ASSETS",
        text: "Published Impulse Magazine 2021",
        category: "work",
        date: "2021"
    },
    {
        id: 6,
        name: "Public Relations Manager",
        institution: "Girlscript Goa",
        text: "Organized community events",
        category: "work",
        date: "2021"
    },
    {
        id: 7,
        name: "Freelance Content Writer",
        institution: "Self-Employed",
        text: "Worked with 20+ happy clients",
        category: "work",
        date: "2020"

    },
    {
        id: 8,
        name: "Software Engineer",
        institution: "Persistent Systems",
        text: "Building React applications",
        category: "work",
        date: "2022"
    },
]